import { Card, Header } from '@breward/ui';
import { useTranslation } from 'react-i18next';
import { BeerGuidelines } from '../types';

interface IngredientsCardProps {
    gl?: BeerGuidelines;
}

export const IngredientsCard = ({ gl }: IngredientsCardProps) => {
    const [t] = useTranslation();

    if (!gl) return null;

    const hasMalts = !!gl.ingredientsMalts;
    const hasHops = !!gl.ingredientsHops;
    const hasYeast = !!gl.ingredientsYeast;
    const hasWater = !!gl.ingredientsWater;
    const hasExtras = !!gl.ingredientsExtras;

    if (!hasMalts && !hasHops && !hasYeast && !hasWater && !hasExtras) {
        if (!gl.ingredients) return null;
        return (
            <Card id="section-ingredients" className="scroll-mt-20">
                <div className="col-span-12 flex flex-col gap-4 font-sans">
                    <Header
                        variant="card"
                        title={t('Pages:ParticipantWeb.ShowStylePage.Ingredients.label', 'Surowce')}
                        icon={<div className="icon-[ph--beer-bottle]" />}
                    />
                    <p className="text-sm text-primary-800 dark:text-primary-100 leading-relaxed">
                        {gl.ingredients}
                    </p>
                </div>
            </Card>
        );
    }

    return (
        <Card id="section-ingredients" className="scroll-mt-20">
            <div className="col-span-12 flex flex-col gap-4 font-sans">
                <Header
                    variant="card"
                    title={t('Pages:ParticipantWeb.ShowStylePage.Ingredients.label', 'Surowce')}
                    icon={<div className="icon-[ph--beer-bottle]" />}
                />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
                    {gl.ingredientsMalts && (
                        <div className="space-y-1">
                            <div className="flex items-center gap-2 text-amber-700 dark:text-amber-400 font-semibold text-sm">
                                <div className="icon-[ph--cookie-fill] h-4 w-4" />
                                <span>{t('Pages:ParticipantWeb.ShowStylePage.Ingredients.malts', 'Słody')}</span>
                            </div>
                            <p className="text-xs text-primary-600 dark:text-primary-300 leading-relaxed pl-6">
                                {gl.ingredientsMalts}
                            </p>
                        </div>
                    )}

                    {gl.ingredientsHops && (
                        <div className="space-y-1">
                            <div className="flex items-center gap-2 text-emerald-700 dark:text-emerald-400 font-semibold text-sm">
                                <div className="icon-[ph--leaf-fill] h-4 w-4" />
                                <span>{t('Pages:ParticipantWeb.ShowStylePage.Ingredients.hops', 'Chmiele')}</span>
                            </div>
                            <p className="text-xs text-primary-600 dark:text-primary-300 leading-relaxed pl-6">
                                {gl.ingredientsHops}
                            </p>
                        </div>
                    )}

                    {gl.ingredientsYeast && (
                        <div className="space-y-1">
                            <div className="flex items-center gap-2 text-indigo-700 dark:text-indigo-400 font-semibold text-sm">
                                <div className="icon-[ph--flask-fill] h-4 w-4" />
                                <span>{t('Pages:ParticipantWeb.ShowStylePage.Ingredients.yeast', 'Drożdże')}</span>
                            </div>
                            <p className="text-xs text-primary-600 dark:text-primary-300 leading-relaxed pl-6">
                                {gl.ingredientsYeast}
                            </p>
                        </div>
                    )}

                    {gl.ingredientsWater && (
                        <div className="space-y-1">
                            <div className="flex items-center gap-2 text-blue-700 dark:text-blue-400 font-semibold text-sm">
                                <div className="icon-[ph--drop-fill] h-4 w-4" />
                                <span>{t('Pages:ParticipantWeb.ShowStylePage.Ingredients.water', 'Woda')}</span>
                            </div>
                            <p className="text-xs text-primary-600 dark:text-primary-300 leading-relaxed pl-6">
                                {gl.ingredientsWater}
                            </p>
                        </div>
                    )}

                    {gl.ingredientsExtras && (
                        <div className="space-y-1 md:col-span-2">
                            <div className="flex items-center gap-2 text-purple-700 dark:text-purple-400 font-semibold text-sm">
                                <div className="icon-[ph--sparkle-fill] h-4 w-4" />
                                <span>{t('Pages:ParticipantWeb.ShowStylePage.Ingredients.extras', 'Dodatki')}</span>
                            </div>
                            <p className="text-xs text-primary-600 dark:text-primary-300 leading-relaxed pl-6">
                                {gl.ingredientsExtras}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};
